export default __webpack_public_path__ + "static/media/cronos-icon.8dca2779.svg";